import { Audiobook, AudiobookPerson } from '../api/audiobooks';

type RoleValue = 'author' | 'narrator' | 'both' | string;

export function personRoleValue(role: unknown): RoleValue | undefined {
  if (!role) {
    return undefined;
  }

  if (typeof role === 'object') {
    const value = (role as { value?: unknown }).value;
    return typeof value === 'string' ? value : undefined;
  }

  return typeof role === 'string' ? role : undefined;
}

export function narratorName(book: Audiobook | null | undefined) {
  const people = book?.people ?? [];
  const narrator = people.find((person: AudiobookPerson) => {
    const pivotRole = personRoleValue(person.pivot_role);
    const role = personRoleValue(person.role);

    return pivotRole === 'narrator' || pivotRole === 'both' || role === 'narrator' || role === 'both';
  });

  return narrator?.name ?? people[0]?.name ?? book?.publisher ?? '';
}

export function personRoleLabel(role: unknown) {
  const value = personRoleValue(role);

  if (value === 'author') {
    return 'Tác giả';
  }

  if (value === 'narrator') {
    return 'Người đọc sách';
  }

  if (value === 'both') {
    return 'Người đọc sách';
  }

  return typeof value === 'string' ? value : '';
}
